export const PLANS_CONSTANTS = {
  // Plan details
  FETCH_PLAN_DETAILS_REQUEST: "FETCH_PLAN_DETAILS_REQUEST",
  FETCH_PLAN_DETAILS_SUCCESS: "FETCH_PLAN_DETAILS_SUCCESS",
  FETCH_PLAN_DETAILS_FAILURE: "FETCH_PLAN_DETAILS_FAILURE",
};
